enum DISPLAY_MODE {
    DARK = 'dark',
    LIGHT = 'light',
    DEFAULT = 'default'
}

enum WEEKDAY {
    MONDAY = 'mon',
    TUESDAY = 'tue',
    WEDNESDAY = 'wed',
    THURSDAY = 'thu',
    FRIDAY = 'fri',
    SATURDAY = 'sat',
    SUNDAY = 'sun'
}

enum MONTH {
    JANUARY = 'january',
    FEBRUARY = 'february',
    MARCH = 'march',
    APRIL = 'april',
    MAY = 'may',
    JUNE = 'june',
    JULY = 'july',
    AUGUST = 'august',
    SEPTEMBER = 'september',
    OCTOBER = 'october',
    NOVEMBER = 'november',
    DECEMBER = 'december'
}

enum REPEAT_CYCLE {
    ONCE = 'once',
    WEEK = 'week',
    MONTH = 'month'
}

enum OFFLINE_ACTION {
    PATCH_ITEM = 'PATCH_ITEM',
    ADD_ITEM = 'ADD_ITEM',
    DELETE_ITEM = 'DELETE_ITEM'
}

enum APP_ENVIROMENT {
    WEB = 'WEB',
    APP = 'APP'
}

enum TICKET_PRIORITY {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high'
}

enum ISSUE_TYPE {
    FEATURE = 'feature',
    BUG = 'bug'
}

enum TICKET_CONTACT_WAY {
    NONE = 'none',
    EMAIL = 'email',
    PHONE = 'phone',
    EMAIL_OR_PHONE = 'emailOrPhone',
}

export {
    OFFLINE_ACTION,
    DISPLAY_MODE,
    WEEKDAY,
    REPEAT_CYCLE,
    MONTH,
    APP_ENVIROMENT,
    TICKET_PRIORITY,
    ISSUE_TYPE,
    TICKET_CONTACT_WAY
}
